import React, { useCallback } from "react";
import { PromoWidgetContainer } from "../../../styles/promoWidget";
import { useHomeData } from "../../../contexts/HomeDataContext";
import { IBanner, ProgressState } from "../../../interfaces/home";
import PromoWidgetShimmer from "./PromoWidgetShimmer";
import { ErrorComponent } from "../../errorComponent";
import PromoWidgetSuccessView from "./PromoWidgetSuccessView";
import { isValidData } from "utils/object";

const PromoWidget = () => {
    const { banners, retryBanners } = useHomeData();
    const { state, data } = banners;

    const getStateToRender = useCallback(() => {
        switch (state) {
            case ProgressState.IN_PROGRESS:
                return <PromoWidgetShimmer />;
            case ProgressState.COMPLETED:
                if (!isValidData(data)) {
                    return null;
                }
                return <PromoWidgetSuccessView banners={data as IBanner[]} />;
            case ProgressState.FAILED:
                return <ErrorComponent onRetry={retryBanners} />;
            default:
                return null;
        }
    }, [state, data, retryBanners]);

    return <PromoWidgetContainer>{getStateToRender()}</PromoWidgetContainer>;
};

export default PromoWidget;
